import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { WithContext as ReactTags } from 'react-tag-input';
import { Icon, Tooltip } from 'antd'
import { isEmail, sendNotification } from '../../utils/index'
import './tags.css'


export class Tags extends Component {

  constructor(props) {
    super(props)

    this.state = {
      tags: [],
      placeholder: 'Agregar nuevo tag',
    }
  }

  componentDidMount() {
    const { fillTags } = this.props

    if (fillTags) {
      this.setState({
        tags: fillTags.map(r => { return { id: r, text: r } })
      })
    }
  }

  componentDidUpdate(prevProps) {
    const { clear } = this.props
    if (prevProps.clear !== clear && clear) {
      this.setState({
        tags: []
      })
    }
  }

  handleAddition = tag => {
    const { validateIsEmail } = this.props
    if (validateIsEmail) {
      if (!isEmail(tag.text)) {
        sendNotification('warning', 'Debes ingresar un correo válido')
        this.props.handleError(true)
        return
      } else {
        this.props.handleError(false)
      }
    }
    const { tags } = this.state
    this.setState(state => ({ tags: [...state.tags, tag] }));
    this.props.handleTags({ tags: [...tags, tag] })
  }

  handleDelete = i => {
    const { tags } = this.state;
    const aux = tags.filter((tag, index) => index !== i)
    this.setState({
      tags: aux
    })
    this.props.handleTags({
      tags: aux
    })

  }

  handleCopyClipboard = () => {
    const { validateIsEmail } = this.props

    if (!validateIsEmail) {
      const { tags } = this.state
      if (tags && tags.length > 0) {
        const tag = tags.map(r => { return r.id })
        const tagsToText = tag.join(',')
        let textField = document.createElement('textarea')
        textField.innerText = tagsToText
        document.body.appendChild(textField)
        textField.select()
        document.execCommand('copy')
        textField.remove()
        sendNotification('success', 'Tags copiados al portapapeles')
      }
      else {
        sendNotification('info', 'No hay Tags para copiar')
      }
    }
  }

  handleInputBlur = (tag) => {
    const { tags } = this.state
    const { validateIsEmail } = this.props
    if (!validateIsEmail) {
      this.props.handleTags({ tags })
    } else {
      if (tag && tag !== '') {
        const handleTag = { id: tag, text: tag }
        this.handleAddition(handleTag)
      }
    }
  }


  render() {
    const { tags, placeholder } = this.state
    const { suggestions, placeholderCustom, validateIsEmail } = this.props

    let placeholderComponent

    if (placeholderCustom) {
      placeholderComponent = placeholderCustom
    } else {
      placeholderComponent = placeholder
    }

    return (
      <React.Fragment>
        {!validateIsEmail &&
          <Tooltip title='Copiar Tags'>
            <Icon type='copy' onClick={this.handleCopyClipboard} />
          </Tooltip>
        }
        <ReactTags tags={tags}
          allowDragDrop={false}
          suggestions={suggestions}
          handleAddition={this.handleAddition}
          handleDelete={this.handleDelete}
          handleTagClick={this.handleTagClick}
          handleInputBlur={this.handleInputBlur}
          // delimiters={delimiters}
          placeholder={placeholderComponent}
        ></ReactTags>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => ({

})

const mapDispatchToProps = {

}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(Tags)))